<template>
  <div class="py-8">
    <div
      v-if="purchaseStatus == 'completed'"
      class="flex justify-center"
    >
      <div class="flex items-center justify-center">
        <img
          :src="cdn('images/site_created_img.png')"
          style="width:60px ; height: 55px;"
          alt=""
          srcset=""
        >
      </div>
    </div>
    <div
      v-if="purchaseStatus == 'failed'"
      class="flex justify-center"
    >
      <img
        :src="cdn('images/payment-failed.gif')"
        style="width:70px ; height: 70px"
        alt=""
        srcset=""
      >
    </div>
    <h3
      v-if="purchaseStatus == 'completed'"
      class="mt-6 text-center text-2xl font-bold text-grayCust-1600"
    >
      {{ $t('purchase_successful') }}
    </h3>
    <h3
      v-if="purchaseStatus == 'failed'"
      class="mt-6 text-center text-2xl font-bold text-grayCust-1600"
    >
      {{ $t('purchase_failed') }}
    </h3>
    <h6
      v-if="purchaseStatus == 'completed'"
      class="text-center text-base font-normal text-grayCust-550"
    >
      {{ $t('your_site_will_be_created_in_a_moment') }}
    </h6>
    <h6
      v-if="purchaseStatus == 'failed'"
      class="text-center text-base font-normal text-grayCust-550"
    >
      {{ failReason }}
    </h6>
    <div
      v-if="purchaseStatus == 'failed'"
      class="mt-2 cursor-pointer text-center text-base font-medium text-primary-900"
      @click="back()"
    >
      {{ $t('go_back') }}
    </div>
  </div>
</template>

<script>

export default {
    name: "PaymentStatus",
    
    props:{
        purchaseStatus: {
            default: '',
            type: String,
        },
        failReason: {
            default: '',
            type: String,
        },
    },
    methods: {
        back() {
            this.$emit('startProcess');
        }
    }
}
</script>
